import store from 'store'
import SuperAdminActions from 'store/redux/superadmin'

export default socket => {
    socket.on('superadmin_mc_list', response => {
        console.tron.log('SOCKET RECEIVED - superadmin_mc_list:')
        console.tron.log(response)
        store.dispatch(SuperAdminActions.handleMcList(response))
    })
    socket.on('superadmin_mc_created', response => {
        console.tron.log('SOCKET RECEIVED - superadmin_mc_created:')
        console.tron.log(response)
        store.dispatch(SuperAdminActions.handleNewMc(response))
    })
    socket.on('superadmin_mc_updated', response => {
        console.tron.log('SOCKET RECEIVED - superadmin_mc_updated:')
        console.tron.log(response)
        store.dispatch(SuperAdminActions.handleUpdateMc(response))
    })
    socket.on('superadmin_mc_updated_password', response => {
        console.tron.log('SOCKET RECEIVED - superadmin_mc_updated_password:')
        console.tron.log(response)
        store.dispatch(SuperAdminActions.handleUpdateMcPassword(response))
    })
    socket.on('superadmin_mc_deleted', response => {
        console.tron.log('SOCKET RECEIVED - superadmin_mc_deleted:')
        console.tron.log(response)
        store.dispatch(SuperAdminActions.handleDeleteMc(response))
    })
    socket.on('superadmin_config_file_data', response => {
        console.tron.log('SOCKET RECEIVED - superadmin_config_file_data:')
        console.tron.log(response)
        store.dispatch(SuperAdminActions.handleConfigFileData(response))
    })
    socket.on('superadmin_updated_config_file', response => {
        console.tron.log('SOCKET RECEIVED - superadmin_updated_config_file:')
        console.tron.log(response)
        store.dispatch(SuperAdminActions.handleUpdatedConfigFile(response))
    })
    socket.on('superadmin_error', response => {
        console.tron.log('SOCKET RECEIVED - superadmin_error:')
        console.tron.log(response)
        store.dispatch(SuperAdminActions.handleServerError(response))
    })
}



// WEBPACK FOOTER //
// src/api/listeners/superadmin.js